/** Incoming call is only live if createdAt is known and recent. Missing timestamp ≠ ringing. */
export const INCOMING_CALL_MAX_AGE_MS = 60_000;

export function firestoreTsToMs(ts: unknown): number | null {
  if (ts && typeof (ts as { toMillis?: () => number }).toMillis === 'function') {
    return (ts as { toMillis: () => number }).toMillis();
  }
  return null;
}

export function isFreshIncomingCallSession(
  doc: { createdAt?: unknown },
  nowMs = Date.now()
): boolean {
  const ms = firestoreTsToMs(doc.createdAt);
  if (ms == null) return false;
  return nowMs - ms >= 0 && nowMs - ms < INCOMING_CALL_MAX_AGE_MS;
}

/** Own just-created ringing session may not have createdAt until the server ack. */
export function isLiveOutgoingRingingSession(
  doc: { state?: string; initiatorUid?: string; createdAt?: unknown },
  uid: string,
  nowMs = Date.now()
): boolean {
  if (doc.state !== 'ringing' || !uid || doc.initiatorUid !== uid) return false;
  if (firestoreTsToMs(doc.createdAt) == null) return true;
  return isFreshIncomingCallSession(doc, nowMs);
}
